export const DOCUMENT_ORIGIN = {
    patient: 'patient',
    professional: 'professional',
    healthcareProfessional: 'healthcare_professional',
    chat: 'chat',
} as const;

export const DOCUMENT_AUTHOR = {
    patient: 'patient',
    professional: 'professional',
} as const;

export const DOCUMENT_STATUS = {
    uploadedByProfessional: 'uploadedByProfessional',
    pendingProfessionalView: 'pendingProfessionalView',
    viewedByProfessional: 'viewedByProfessional',
} as const;

export const DOCUMENT_ITEM_KIND = {
    telemonitoringReport: 'telemonitoringReport',
    appointmentReport: 'appointmentReport',
    document: 'document',
} as const;

export const DOCUMENT_FILE_KIND = {
    pdf: 'pdf',
    image: 'image',
    other: 'other',
} as const;

export const DOCUMENT_META_TYPE = {
    period: 'period',
    visit: 'visit',
    upload: 'upload',
} as const;

export const DOCTOR_TITLE = {
    male: 'male_doctor',
    female: 'female_doctor',
} as const;

export const DOCTOR_GENDER = {
    male: 'male',
    female: 'female',
    neutral: 'neutral',
} as const;

export const DOCUMENTS_IMAGE_MIME_PREFIX = 'image/';

export const DOCUMENTS_MONTH_KEY_FORMAT = 'yyyy-MM';

export const DOCUMENTS_META_SEPARATOR = ' · ';

export const DOCUMENTS_RANGE_DASH = '–';
